import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {getContactCompanyList, setSelectedHetPay, skipSelectCompanyStep, reportDWH , saveToHistory } from '../PortalsBlock/portalSlice';
import {clearBusinessIndividualDataOnSelecthetPay} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import {Container} from 'reactstrap';
import gaParams from '../../../utilities/analytics/constants';
import {gaEvent} from '../../../utilities/analytics/tracking';
import images from '../PortalsBlock/images/images';
import {isBrowser, isMobile} from 'react-device-detect';
import Select from './Select';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import Loader from '../../Shared/LocalLoader/LocalLoader';
import Config from '../../../Config';

function Header({
  context,
  iContent,
  HetPayList,
  firstName,
  lastName,
  getContactCompanyList,
  setSelectedHetPay,
  isFullAuthenticated,
  userRole,
  showAppLoader,
  hideAppLoader,
  selectedHetPay,
  skipSelectCompanyStep,
  clearBusinessIndividualDataOnSelecthetPay,
  reportDWH,
  saveToHistory,
}) {
  const background = Config.epiBaseUrl + iContent.backgroundImage.value.url;
  const selectHetPayList = HetPayList;

  const [dropDownItemValue, setDropDownItemValue] = useState(null);
  const [allowRender, setAllowRender] = useState(false);

  useEffect(() => {
    async function getContactList() {
      if (isFullAuthenticated) {
        await getContactCompanyList();
        setAllowRender(true);
      }
    }
    if (selectedHetPay) {
      setAllowRender(true);
      return;
    }

    getContactList();
  }, [isFullAuthenticated]);

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
    reportDWH({
      actionType: 'Business Account List',
      status: 'Completed',
      messageText: 'Contact Entry Personal Area',
      param1: selectedHetPay,
      subArea: 'BusinessSelfCareArea',
    });

    gaEvent(gaParams.BUSINESS_PORTAL_ENTER_PORTAL.category, gaParams.BUSINESS_PORTAL_ENTER_PORTAL.eventType, userRole);
  }, []);

  useEffect(() => {
    if (selectedHetPay) {
      saveToHistory();
      reportDWH({
        actionType: 'Business Contact Lobby',
        status: 'Ongoing',
        messageText: 'Business Account Clicked (ח.פ.)',
        param1: selectedHetPay,
        subArea: 'BusinessSelfCareArea',
      });
    }
  }, [selectedHetPay]);

  function updateChoiceOfHetPay(id) {
    setSelectedHetPay(id);
    setDropDownItemValue(id);
    skipSelectCompanyStep(true);
    clearBusinessIndividualDataOnSelecthetPay();
  }

  function dwhReportOnOpen() {
    reportDWH({
      actionType: 'Business Account List',
      status: 'Ongoing',
      messageText: 'Business Account List Displayed',
      subArea: 'BusinessSelfCareArea',
    });
  }

  function renderView() {
    if (allowRender) {
      if (isBrowser) {
        return (
          <Container style={{backgroundImage: `url(${background})`}} className='header-container-root'>
            <div className='all-items-row'>
              <div className='headers-container'>
                <h3 className='headers'>שלום,</h3>
                <h2 className='headers-bold'>
                  {firstName} {lastName}
                </h2>
              </div>
              {selectHetPayList && selectHetPayList.length == 1 ? (
                <Select
                  options={selectHetPayList}
                  onChange={(id) => updateChoiceOfHetPay(id)}
                  value={selectHetPayList[0].id}
                  displayArrow={true}
                  isOpen={false}
                  dwhReport={dwhReportOnOpen}
                />
              ) : selectedHetPay ? (
                <Select
                  options={selectHetPayList}
                  onChange={(id) => updateChoiceOfHetPay(id)}
                  value={selectedHetPay}
                  displayArrow={false}
                  isOpen={false}
                  dwhReport={dwhReportOnOpen}
                />
              ) : (
                <Select
                  options={selectHetPayList}
                  placeholder='על איזה ח.פ מדובר?'
                  onChange={(id) => updateChoiceOfHetPay(id)}
                  value={dropDownItemValue}
                  displayArrow={false}
                  isOpen={true}
                  dwhReport={dwhReportOnOpen}
                />
              )}
            </div>
            <div className='white-div-round-corner'></div>
          </Container>
        );
      } else {
        return (
          <Container style={{backgroundImage: `url(${images.background})`}} className='header-container-root'>
            <div className='all-items-row'>
              <div className='headers-container'>
                <h3 className='headers'>שלום,</h3>
                <h2 className='headers-bold'>
                  {firstName} {lastName}
                </h2>
              </div>
              {selectHetPayList && selectHetPayList.length == 1 ? (
                <Select
                  options={selectHetPayList}
                  onChange={(id) => updateChoiceOfHetPay(id)}
                  value={selectHetPayList[0].id}
                  displayArrow={true}
                  isOpen={false}
                />
              ) : (
                <Select
                  options={selectHetPayList}
                  placeholder='על איזה ח.פ מדובר?'
                  onChange={(id) => updateChoiceOfHetPay(id)}
                  value={dropDownItemValue}
                  displayArrow={true}
                  isOpen={true}
                />
              )}
            </div>
            <div className='white-div-round-corner'></div>
          </Container>
        );
      }
    } else {
      return <Loader />;
    }
  }

  return renderView();
}

const mapStateToProps = (state) => ({
  HetPayList: state.portalsBlock.hetPaysNumbers,
  firstName: state.portalsBlock.firstName,
  lastName: state.portalsBlock.lastName,
  isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
  userRole: state.authentication.loginData.userDetails.role,
  selectedHetPay: state.portalsBlock.selectedHetPay,
});

const mapDispatchToProps = {
  getContactCompanyList,
  setSelectedHetPay,
  showAppLoader,
  hideAppLoader,
  skipSelectCompanyStep,
  clearBusinessIndividualDataOnSelecthetPay,
  reportDWH,
  saveToHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);